export default "__VITE_ASSET__B1vZ3BIv__"